
import { useContext, useState, useEffect } from 'react';
import {
    Button, Dialog, Box, makeStyles, TextField
}
    from '@material-ui/core';


//Componentes.
import InputsFilterOptions from '../DynamicDiagram/FilterOptions/InputsFilterOptions';
import GenericFilterOptions from '../DynamicDiagram/FilterOptions/GenericFilterOptions';
import MbsFilterOptions from '../DynamicDiagram/FilterOptions/MbsFilterOptions';
import MbrFilterOptions from '../DynamicDiagram/FilterOptions/MbrFilterOptions';
import MbxFilterOptions from '../DynamicDiagram/FilterOptions/MbxFilterOptions';
import DynamicFilterOptions from '../DynamicDiagram/FilterOptions/DynamicFilterOptions';
import TwdayFilterOptions from '../DynamicDiagram/FilterOptions/TwdayFilterOptions';
import TmonFilterOptions from '../DynamicDiagram/FilterOptions/TmonFilterOptions';
import SnmpsFilterOptions from '../DynamicDiagram/FilterOptions/SnmpsFilterOptions';
import SnmpxFilterOptions from '../DynamicDiagram/FilterOptions/SnmpxFilterOptions';
import SnmpdAndSnmptFilterOptions from '../DynamicDiagram/FilterOptions/SnmpdAndSnmptFilterOptions';
import TdmFilterOptions from '../DynamicDiagram/FilterOptions/TdmFilterOptions';
import TdateFilterOptions from '../DynamicDiagram/FilterOptions/TdateFilterOptions';
import TmdayFilterOptions from '../DynamicDiagram/FilterOptions/TmdayFilterOptions';
import BlshFilterOptions from '../DynamicDiagram/FilterOptions/BlshFilterOptions';
import TastroFilterOptions from '../DynamicDiagram/FilterOptions/TastroFilterOptions';
//Libreria
import { MarkdownRenderer } from '../DynamicDiagram/FilterOptions/helperDescriptionText';
//Servicios
import { updateBlockDiagramLive, getUpdateBlockDiagramLive } from '../../services/diagrams';

let scrollsSettings = {
    overflow: 'scroll',
    overflowX: 'hidden',
};
let webkitScrollbar = {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#beb1b18f',
    color: 'red',
    width: '9px',
};
let webkitscrollbarTrack = {
    background: '#dfdfe957',
};

const useStyles = makeStyles(theme => ({
    containerMain: {
        ...scrollsSettings,
        '&::-webkit-scrollbar': {
            //son los estilos de las barras scroll en una variable.
            ...webkitScrollbar,
        },
        '&::-webkit-scrollbar-track': {
            //son los estilos de las barras scroll en una variable.
            ...webkitscrollbarTrack,
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.primary.main,
        },
        padding: theme.spacing(1),
        marginLeft: theme.spacing(1),
    },
    btnSpacing: {
        margin: theme.spacing(0, 2),
    },

}));

const ModalSettingsBlock = ({ id, handleOpenModal, openModal, type, blockNodeSettings, setLoading, configBlock, nodes, setLocalState, localState, setClose, setMsg, setDisabledButtonEdit }) => {
    const classes = useStyles();
    const [disabledButtonSave, setDisabledButtonSave] = useState(false)
    const [disableEditing, setDisableEditing] = useState(false)
    //Estado de bloque variable.
    const [varState, setVarState] = useState({
        values: 'SECCION-VARIABLE',
        nodes: [],
        variable_operation: ''
    });

    useEffect(() => {
        setVarState(configBlock)
    }, [])

    const save = () => {
        setLoading(true)
        let body = {
            edges: [],
            nodes: [varState]
        }
        let ID_AUTOMATETOMATE = localState?.automateSelected?.id
        let ID_DIAGRAM = localState?.automateSelected?.diagram?.id
        updateBlockDiagramLive(ID_AUTOMATETOMATE, ID_DIAGRAM, body)
        handleOpenModal()
        getUpdateBlockDiagramLiveAux(ID_AUTOMATETOMATE)
    }

    //Verifica el estado del bloque si cambio o no cambio.
    const getUpdateBlockDiagramLiveAux = async (id_automate) => {
        setDisabledButtonEdit(true)
        let flag = 1
        const auxFunction = async (id_automate) => {
            let res = await getUpdateBlockDiagramLive(id_automate)
            const data = res?.data;
            if (data?.state === 'OK') {
                flag = 8
                setLocalState(prev => ({
                    ...prev,
                    block: varState
                }));
                setClose(true)
                setMsg({
                    msg: 'Configuración aplicada exitosamente',
                    type: 'success'
                })
                setLoading(false)
                setDisabledButtonEdit(false)
            }
            if (data?.msg) {
                flag = 8
                setClose(true)
                setMsg({
                    msg: data.msg,
                    type: 'error'
                })
                setLoading(false)
                setDisabledButtonEdit(false)
            }
        }
        setInterval(() => {
            flag += 1
            if (flag < 9) {
                auxFunction(id_automate)
            }
        }, 2000)
    }

    //Funcion q valida el type de el componente.
    const validateAndComponent = () => {
        return ['AND', 'OR', 'NAND', 'XNOR', 'NOR', 'XOR', 'ADDER', 'MUL', 'BOR', 'BXOR', 'BAND',].includes(type);
    };

    return (
        <Dialog
            open={openModal}
            maxWidth={'lg'}
            onClose={handleOpenModal}
            fullWidth
            disableScrollLock
        >
            <Box className={classes.containerMain}>
                {/* Descripción del bloque */}
                <Box mb={2}>
                    <Box className={classes.content} ml={1}>
                        <MarkdownRenderer markdown={blockNodeSettings?.description || ''} />
                    </Box>
                </Box>

                {/* Componente dinámico según el tipo */}
                <Box mt={3}>
                    {(() => {
                        switch (type) {
                            case 'MBS':
                                return (
                                    <MbsFilterOptions
                                        disableEditing={disableEditing}
                                        blockNodeSettings={blockNodeSettings}
                                        typeBlock={type}
                                        id={id}
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'MBR':
                                return (
                                    <MbrFilterOptions
                                        disableEditing={disableEditing}
                                        blockNodeSettings={blockNodeSettings}
                                        typeBlock={type}
                                        id={id}
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'MBX':
                                return (
                                    <MbxFilterOptions
                                        disableEditing={disableEditing}
                                        blockNodeSettings={blockNodeSettings}
                                        typeBlock={type}
                                        id={id}
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'PID':
                            case 'RAMP':
                                return (
                                    <DynamicFilterOptions
                                        disableEditing={disableEditing}
                                        blockNodeSettings={blockNodeSettings}
                                        typeBlock={type}
                                        id={id}
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'TWDAY':
                                return (
                                    <TwdayFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'TMDAY':
                                return (
                                    <TmdayFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'TMON':
                                return (
                                    <TmonFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'TDM':
                                return (
                                    <TdmFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'TDATE':
                                return (
                                    <TdateFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                    />
                                );
                            case 'SNMPS':
                                return (
                                    <SnmpsFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                        blockNodeSettings={blockNodeSettings}
                                        setDisabledButtonSave={setDisabledButtonSave}
                                    />
                                );
                            case 'SNMPD':
                            case 'SNMPT':
                                return (
                                    <SnmpdAndSnmptFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                        blockNodeSettings={blockNodeSettings}
                                        setDisabledButtonSave={setDisabledButtonSave}
                                    />
                                );
                            case 'SNMPX':
                                return (
                                    <SnmpxFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                        blockNodeSettings={blockNodeSettings}
                                        setDisabledButtonSave={setDisabledButtonSave}
                                    />
                                );
                            case 'BLSH':
                                return (
                                    <BlshFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                        blockNodeSettings={blockNodeSettings}
                                        setDisabledButtonSave={setDisabledButtonSave}
                                    />
                                );
                            case 'TASTRO':
                                return (
                                    <TastroFilterOptions
                                        setVarState={setVarState}
                                        varState={varState}
                                        blockNodeSettings={blockNodeSettings}
                                        setDisabledButtonSave={setDisabledButtonSave}
                                    />
                                );
                            default:
                                if (validateAndComponent()) {
                                    return (
                                        <InputsFilterOptions
                                            disableEditing={disableEditing}
                                            blockNodeSettings={blockNodeSettings}
                                            typeBlock={type}
                                            setDisabledButtonSave={setDisabledButtonSave}
                                            // setHandleSourceQuantity={setHandleSourceQuantity}
                                            // handleSourceQuantity={handleSourceQuantity}
                                            id={id}
                                        />
                                    );
                                } else {
                                    return (
                                        <>
                                            <GenericFilterOptions
                                                disableEditing={disableEditing}
                                                typeBlock={type}
                                                id={id}
                                                blockNodeSettings={blockNodeSettings}
                                                setDisabledButtonSave={setDisabledButtonSave}
                                                nodes={nodes}
                                                setVarState={setVarState}
                                                varState={varState}
                                            />
                                        </>

                                    );
                                }
                        }
                    })()}
                </Box>

                {/* Botones de acción */}
                <Box m={2} mt={4} display="flex" justifyContent="center" alignItems="center">
                    <Button
                        // disabled={disabledButtonSave}
                        onClick={save}
                        variant="contained"
                        color="primary"
                    >
                        Guardar
                    </Button>
                    <Button
                        onClick={handleOpenModal}
                        variant="contained"
                        className={classes.btnSpacing}
                    >
                        Cancelar
                    </Button>
                </Box>

            </Box>
        </Dialog>

    )
}
export default ModalSettingsBlock
